<template>
  <b-card-code id="user-history" class="view-controls controls-page" no-body>

    <b-row>
      <b-col md="12">
        <div class="page-header">
          <b-row>
            <b-col class="filtersContainer" md="12">
              <div class="filters controlFilters">

                <div class="filter-column">
                  <date-range-picker
                      ref="picker"
                      :opens="'center'"
                      v-model="dateRange"
                      :locale-data="localeData"
                      :ranges="dateRanges"
                      :always-show-calendars="false"
                      @update="updateRange"
                  >
                    <template v-slot:input="picker" style="min-width: 350px;">
                      <fa-icon class="header-icon calendarIcon" :icon="['far', 'calendar-alt']"/>
                      {{ selected_picker_value(picker) }}
                    </template>
                  </date-range-picker>
                </div>

                <div class="filter-column">
                  <div @click="toggleDetected" :class="(filters.api === 'detected') ? 'double-checkup active' : 'double-checkup'">
                    <fa-icon icon="check-circle" />
                  </div>
                </div>

                <div class="filter-column">
                  <b-form-input
                      autocomplete="off"
                      @change="getControls"
                      @keydown="disableSymbol($event)"
                      v-model="filters.search"
                      id="owner_name"
                      type="text"
                      placeholder="Փնտրել..."
                      class="w-full text-uppercase opinionFilter"
                      clearable
                  />
                </div>

                <div  class="filter-column">
                  <v-select
                      @input="getControls"
                      placeholder="Կազմակերպություն"
                      id="vue-select"
                      :reduce="prefix => prefix.id"
                      v-model="filters.company"
                      :options="companies"
                      class="companyFilterSelect"
                  />
                </div>

              </div>
            </b-col>
          </b-row>
        </div>
        <b-table
            striped
            hover
            responsive
            class="position-relative"
            :items="controls"
            :fields="fields"
        >
          <template #cell(createdDate)="data">
            <div class="rowItem">
              <span class="itemCount">1.</span>
              <span>{{ data.item.createdDate | formatDate }}</span>
            </div>
            <div class="rowItem">
              <span class="itemCount" :class="!data.item.nextDate ? 'not_detectet' : ''">2.</span>
              <span v-if="data.item.nextDate">{{ data.item.nextDate | formatDate}}</span>
              <span v-else>-</span>
            </div>
          </template>

          <template #cell(message)="data">
            <div style="white-space: break-spaces;">{{ data.value }}</div>
          </template>

          <template #cell(firstCompany)="data">
           <div class="rowItem">
             <span>{{ data.item.firstCompany.name}}</span>
           </div>
            <div class="rowItem">
              <span v-if="data.item.secondCompany">{{ data.item.secondCompany.name}}</span>
              <span v-else>-</span>
            </div>
          </template>

          <template #cell(CarRegNo)="data">
            <span>{{ data.value }}</span>
            <span class="ml-2 cursor-pointer" v-if="data.item.checkup && data.item.checkup.video" @click="openVideoModal(data.item.checkup.video)">▶️</span>
            <span class="ml-2 cursor-pointer" v-if="data.item.checkup && data.item.checkup.video2" @click="openVideoModal(data.item.checkup.video2)">▶️</span>
          </template>

          <template #cell(status)="data">
            <fa-icon v-if="data.item.status" icon="check-circle" class="text-success" style="font-size: 20px" />
            <fa-icon @click="markRead(data.item)" v-else-if="data.item.detected" icon="check-circle" class="text-warning" style="font-size: 20px" />
          </template>

        </b-table>
        <b-card-body class="d-flex justify-content-between flex-wrap pt-0">

          <!-- page length -->
          <b-form-group
              :label="'Գտնվել է ' + pagination.total + ' տող'"
              label-cols="3"
              label-align="left"
              label-size="sm"
              label-for="sortBySelect"
              class="text-nowrap mb-md-0 mr-1"
          >
          </b-form-group>

          <!-- pagination -->
          <div>
            <b-pagination
                @input="getControls"
                v-model="pagination.current_page"
                :total-rows="pagination.total"
                :per-page="pagination.count"
                first-number
                last-number
                prev-class="prev-item"
                next-class="next-item"
                class="mb-0"
            >
              <template #prev-text>
                <feather-icon
                    icon="ChevronLeftIcon"
                    size="18"
                />
              </template>
              <template #next-text>
                <feather-icon
                    icon="ChevronRightIcon"
                    size="18"
                />
              </template>
            </b-pagination>
          </div>

          <b-modal
              id="modal-video"
              :no-close-on-backdrop="true"
              centered
              size="lg"
              title=""
              :is-valid="false"
              :hide-footer="true"
          >
            <b-form class="d-flex justify-content-center align-items-center" v-if="video">
              <video :src="videoUrl" class="w-100" controls preload="auto" playsinline>
                <source :src="videoUrl" type="video/webm">
              </video>
            </b-form>
          </b-modal>
        </b-card-body>
      </b-col>
    </b-row>

  </b-card-code>
</template>

<script>

import moduleControl from '@/store/api/moduleControl'
import store from '@/store'
import {
  BTable,
  BCardBody,
  BFormGroup,
  BPagination,
  BRow,
  BCol,
  BButton,
  BModal,
  BForm,
  BFormInput,
  BFormCheckbox, BBadge
} from 'bootstrap-vue'
import BCardCode from '@core/components/b-card-code/BCardCode'
import vSelect from 'vue-select'
import DateRangePicker from 'vue2-daterange-picker'
import companyModule from "@/store/companies/companyModule";

let thisMonthStart = new Date(new Date().getFullYear(), new Date().getMonth(), 1)
let thisMonthEnd = new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0)

export default {
  name: 'controls',
  components: {
    BCardCode,
    BCardBody,
    BTable,
    BFormGroup,
    BPagination,
    BRow,
    BCol,
    BButton,
    BModal,
    BForm,
    BFormInput,
    BFormCheckbox,
    BBadge,
    vSelect,
    DateRangePicker
  },
  data() {
    return {
      STORE_MODULE_NAME: 'controlModule',
      COMPANIES_STORE_MODULE_NAME: 'companiesModule',
      fields: [
        {
          key: 'createdDate',
          label: 'Ամսաթիվ/ժամ'
        },
        {
          key: 'firstCompany',
          label: 'ՏԶ Կայան'
        },
        {
          key: 'CarRegNo',
          label: 'Համարանիշ'
        },
        {
          key: 'car',
          label: 'Մեքենա'
        },
        {
          key: 'message',
          label: 'Պատճառ'
        },
        {
          key: 'status',
          label: '✅'
        }
      ],
      filters: {
        search: null,
        company: null,
      },
      apis: [
        {
          id: 'all',
          label: 'Բոլորը'
        },
        {
          id: 'detected',
          label: 'Տեխզննում անցածները'
        }
      ],
      dateRange: {
        startDate: null,
        endDate: null
      },
      localeData: {
        applyLabel: 'Հաստատել',
        cancelLabel: 'Չեղարկել',
        ranges: [],
        firstDay: 1,
        format: 'dd/mm/yyyy',
        customRangeLabel: 'Այլ',
        daysOfWeek: ['Կիր', 'Երկ', 'Երք', 'Չոր', 'Հնգ', 'Ուրբ', 'Շբթ'],
        monthNames: ['Հուն', 'Փետ', 'Մար', 'Ապր', 'Մայ', 'Հուն', 'Հուլ', 'Օգ', 'Սեպ', 'Հոկ', 'Նոյ', 'Դեկ'],
        taxData: []
      },
      video: null,
    }
  },
  computed: {

    companies() {
      const companies = [...this.$store.state[this.COMPANIES_STORE_MODULE_NAME].companies]
          .sort((a, b) => a.name.localeCompare(b.name)); // sort by name

      const mappedCompanies = companies.map(e => ({
        label: e.name,
        id: e._id
      }));

      if (this.$device.isMobile) {
        return mappedCompanies;
      }

      return [
        {
          label: 'Կազմակերպություն',
          value: null,
          disabled: true
        },
        ...mappedCompanies
      ];
    },

    users() {
      return this.$store.state[this.STORE_MODULE_NAME].users
    },
    pagination() {
      return this.$store.state[this.STORE_MODULE_NAME].pagination
    },
    controls() {
      return this.$store.state[this.STORE_MODULE_NAME].controls
    },
    color () {
      return (item) => {
        if(item === false) {
          return 'danger'
        } else if (item === true) {
          return 'success'
        } else {
          return 'warning'
        }
      }
    },
    icon() {
      return (item) => {
        if(item === false) {
          return 'times-circle'
        } else if (item === true) {
          return 'check-circle'
        } else {
          return 'info-circle'
        }
      }
    },
    dateRanges() {
      // Today
      let today = new Date()

      let allStart = new Date(this.firstCheckupDate)

      let todayStart = new Date()
      let todayEnd = new Date()

      // Yesterday
      let yesterdayStart = new Date()
      yesterdayStart.setDate(today.getDate() - 1)
      let yesterdayEnd = new Date()
      yesterdayEnd.setDate(today.getDate() - 1)

      // This week
      let thisWeekStart = new Date(new Date().setDate(new Date().getDate() + 1 - new Date().getDay()))
      let thisWeekEnd = new Date(new Date().setDate(new Date().getDate() + 1 - new Date().getDay() + 6))

      // Last Week
      let lastWeekStart = new Date(new Date().setDate(new Date().getDate() - 6 - new Date().getDay()))
      let lastWeekEnd = new Date(new Date().setDate(new Date().getDate() - new Date().getDay()))

      // This Month
      let thisMonthStart = new Date(new Date().getFullYear(), new Date().getMonth(), 1)
      let thisMonthEnd = new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0)

      // Last Month
      let lastMonthStart = new Date(today.getFullYear(), today.getMonth() - 1, 1)
      let lastMonthEnd = new Date(today.getFullYear(), today.getMonth(), 0)

      // This Quarter
      let currentMonth = today.getMonth()
      let currentYear = today.getFullYear()
      let thisQuarterStart
      let thisQuarterEnd
      let lastQuarterStart
      let lastQuarterEnd
      if (currentMonth >= 0 && currentMonth < 3) {
        thisQuarterStart = new Date(today.getFullYear(), 0, 1)
        thisQuarterEnd = new Date(new Date().getFullYear(), 2, 31)

        lastQuarterStart = new Date(today.getFullYear() - 1, 9, 1)
        lastQuarterEnd = new Date(today.getFullYear() - 1, 11, 31)
      } else if (currentMonth >= 3 && currentMonth < 6) {
        thisQuarterStart = new Date(today.getFullYear(), 3, 1)
        thisQuarterEnd = new Date(new Date().getFullYear(), 5, 30)

        lastQuarterStart = new Date(today.getFullYear(), 0, 1)
        lastQuarterEnd = new Date(new Date().getFullYear(), 2, 31)
      } else if (currentMonth >= 6 && currentMonth < 9) {
        thisQuarterStart = new Date(today.getFullYear(), 6, 1)
        thisQuarterEnd = new Date(new Date().getFullYear(), 8, 30)

        lastQuarterStart = new Date(today.getFullYear(), 3, 1)
        lastQuarterEnd = new Date(new Date().getFullYear(), 5, 30)
      } else if (currentMonth >= 9 && currentMonth < 12) {
        thisQuarterStart = new Date(today.getFullYear(), 9, 1)
        thisQuarterEnd = new Date(new Date().getFullYear(), 11, 31)

        lastQuarterStart = new Date(today.getFullYear(), 3, 1)
        lastQuarterEnd = new Date(new Date().getFullYear(), 5, 30)
      }

      let thisSemesterStart
      let thisSemesterEnd
      let lastSemesterStart
      let lastSemesterEnd
      if (currentMonth >= 0 && currentMonth < 5) {
        thisSemesterStart = new Date(today.getFullYear(), 0, 1)
        thisSemesterEnd = new Date(new Date().getFullYear(), 5, 30)

        lastSemesterStart = new Date(today.getFullYear() - 1, 6, 1)
        lastSemesterEnd = new Date(today.getFullYear() - 1, 11, 31)

      } else {
        thisSemesterStart = new Date(today.getFullYear(), 6, 1)
        thisSemesterEnd = new Date(new Date().getFullYear(), 11, 31)

        lastSemesterStart = new Date(today.getFullYear(), 0, 1)
        lastSemesterEnd = new Date(today.getFullYear(), 5, 30)
      }

      // This Year
      let thisYearStart = new Date(new Date().getFullYear(), 0, 1)
      let thisYearEnd = new Date(new Date().getFullYear(), 11, 31)

      // Last Year
      let lastYearStart = new Date(new Date().getFullYear() - 1, 0, 1)
      let lastYearEnd = new Date(new Date().getFullYear() - 1, 11, 31)

      const data = {
        'Այսօր': [todayStart, todayEnd],
        'Երեկ': [yesterdayStart, yesterdayEnd],
        'Այս շաբաթ': [thisWeekStart, thisWeekEnd],
        'Անցած շաբաթ': [lastWeekStart, lastWeekEnd],
        'Այս ամիս': [thisMonthStart, thisMonthEnd],
        'Անցած ամիս': [lastMonthStart, lastMonthEnd],
        'Այս եռամսյակ': [thisQuarterStart, thisQuarterEnd],
        'Անցած եռամսյակ': [lastQuarterStart, lastQuarterEnd],
        'Այս կիսամյակ': [thisSemesterStart, thisSemesterEnd],
        'Անցած կիսամյակ': [lastSemesterStart, lastSemesterEnd],
        'Այս տարի': [thisYearStart, thisYearEnd],
        'Անցած տարի': [lastYearStart, lastYearEnd],
        'Բոլորը': [null, null],
      }

      if (this.userType === 'VIEWER') {
        delete data['Բոլորը']
      }

      return data
    },
    selected_picker_value() {
      return (data) => {
        if (data.startDate && data.endDate) {
          return this.$options.filters.formatDay(data.startDate) + ' - ' + this.$options.filters.formatDay(data.endDate)
        }
        return '';
      }
    },
    videoUrl() {
      let url = process.env.VUE_APP_API_URL;
      url += '/' + this.video;
      return url;
    },
  },
  created() {
    if (!store.hasModule(this.STORE_MODULE_NAME)) store.registerModule(this.STORE_MODULE_NAME, moduleControl)
    if (!store.hasModule(this.COMPANIES_STORE_MODULE_NAME)) store.registerModule(this.COMPANIES_STORE_MODULE_NAME, companyModule)
    this.getControls()
    this.getCompanies()
  },
  methods: {
    getCompanies() {
      this.$store.dispatch(this.COMPANIES_STORE_MODULE_NAME + '/getCompanies', true)
    },

    openVideoModal(video) {
      this.video = video;
      this.$bvModal.show(`modal-video`)
    },
    updateRange() {
      this.dateRange.startDate.setHours(0, 0, 0, 0)
      this.dateRange.endDate.setHours(23, 59, 59, 59)
      this.getControls()
    },
    toggleDetected() {
      this.filters.api = this.filters.api === null ? 'detected' : null
      this.getControls()
    },
    getControls() {
      this.$vs.loading()
      const filterData = {
        ...this.dateRange,
        ...this.filters,
        current_page: this.pagination.current_page,
      }
      if (this.filters.api) {
        if (this.filters.api === 'detected') {
          filterData.detected = true
        } else {
          delete filterData.detected
        }
      }
      this.$store.dispatch(`${this.STORE_MODULE_NAME}/getControls`, this.serialize(filterData))
          .then(() => {
            this.$vs.loading.close()
          })
          .catch(error => {
            this.$vs.loading.close()
            this.$root.$emit('getError', error)
          })
    },
    serialize(obj) {
      let str = []
      for (let p in obj) {
        if (obj.hasOwnProperty(p)) {
          if (typeof obj[p] !== 'undefined' && obj[p] !== null && obj[p] !== '') {
            str.push(encodeURIComponent(p) + '=' + encodeURIComponent(obj[p]))
          }
        }
      }
      return str.join('&')
    },
    markRead(item) {
      this.$vs.loading()
      let payload = {
        status: true
      }
      this.$store.dispatch(`${this.STORE_MODULE_NAME}/updateControls`, {
        id: item._id,
        data: payload
      })
          .then(() => {
            this.$vs.loading.close()
          })
          .catch(error => {
            this.$vs.loading.close()
            this.$root.$emit('getError', error)
          })
    }
  }
}
</script>
<style lang="scss">
#user-history {
  .table-responsive {
    max-height: calc(var(--vh, 1vh) * 100 - 16rem);
    min-height: calc(var(--vh, 1vh) * 100 - 16rem);
  }
}
.view-controls table td, .view-controls table th {
  font-size: 15px;
  font-weight: bold;
}
.view-controls table tr{
  border-bottom: 1px solid #ebe9f1;
}
.status_badge {
  width: 150px;
}
.rowItem {
  display: flex;
  margin-bottom: 15px;
}
.rowItem:first-child {
  border-bottom: 1px solid #d7d7d7;
  width: 100%;
  padding-bottom: 20px;
}
.itemCount {
  background: var(--success);
  color: #fff;
  width: 23px;
  height: 23px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  margin-right: 10px;
}
.itemCount {
  &.not_detectet {
    background: var(--warning);
  }
}
.controls-page .double-checkup {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid #ccc;
  padding: 0 13px;
  cursor: pointer;
  height: 100%;
  &.active {
    background: #2e2e2e;
    color: #fff;
  }
}
.controls-page .double-checkup {
  padding: 10px 23px;
  cursor: pointer;
  background: #E9EDF6;
  color: #164866;
  border-radius: 26px;
  font-weight: bold;
}
.controls-page .filters.controlFilters .daterangepicker {
  left: 24.6% !important;
  top: 14% !important;
}
.controls-page  .vue-daterange-picker {
  margin-bottom: 0rem !important;
}
</style>
